import { Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import useClientPlants from "../../../../../../../../hooks/useClientPlants";
import NumberedTitle from "../shared/NumberedTitle";
import DocReviewer from "../../../../DCSTab/DocReviewer";

export default function ITP() {
  const { plantId } = useParams();
  const { plants } = useClientPlants();
  const plant = plants.find((p) => String(p.id) === String(plantId)) || {
    id: plantId,
  };

  return (
    <Box>
      <NumberedTitle number="5" title="Inspection & Test Plan" />
      {/* Show DCS Doc Reviewer filtered to Quality Control documents for this plant */}
      <Box mt={2}>
        <DocReviewer
          plant={plant}
          initialType="Quality Control"
          hideTypeSelector={true}
        />
      </Box>
    </Box>
  );
}
